import apiClient from "@/api/client";
import { uploadManagedFile } from "@/utils/managedFile";
import type { ManagedFileBrief, OrderComment } from "../types";

export const orderCommentsApi = {
  list: (orderId: string) =>
    apiClient
      .get<{ data: OrderComment[] }>("/orders/comments/", { params: { order: orderId } })
      .then((r) => r.data.data),

  // Two-step upload: push the raw file to the central file registry, then reference
  // the returned ManagedFile id when creating the comment.
  uploadFile: (file: File) => uploadManagedFile<ManagedFileBrief>(file),

  create: (payload: {
    order: string;
    body: string;
    is_critical: boolean;
    mention_ids?: string[];
    files?: string[];
  }) => apiClient.post<{ data: OrderComment }>("/orders/comments/", payload).then((r) => r.data.data),

  editBody: (id: string, body: string) =>
    apiClient.patch<{ data: OrderComment }>(`/orders/comments/${id}/`, { body }).then((r) => r.data.data),

  acknowledge: (id: string) =>
    apiClient
      .patch<{ data: OrderComment }>(`/orders/comments/${id}/`, { status: "acknowledged" })
      .then((r) => r.data.data),

  delete: (id: string) => apiClient.delete(`/orders/comments/${id}/`),

  pendingCount: () =>
    apiClient
      .get<{ data: { count: number } }>("/orders/comments/pending-count/")
      .then((r) => r.data.data.count),
};
